import { ref, watch } from 'vue'

// Per-device toggle for the global keyboard shortcuts (App.vue). Local only —
// like theme, there's no reason this needs to sync across devices.
const STORAGE_KEY = 'shortcutsEnabled'

const shortcutsEnabled = ref(localStorage.getItem(STORAGE_KEY) !== 'false')

watch(shortcutsEnabled, val => {
  try { localStorage.setItem(STORAGE_KEY, String(val)) } catch { /* private mode, etc — non-fatal */ }
})

export function useShortcutsEnabled() {
  return { shortcutsEnabled }
}
